import { IColumn } from "shared/ui/Table/constants";

export const templateColumns: IColumn[] = [
  {
    label: "id",
    field: "id",
  },
  {
    label: "name",
    field: "name",
  },
];
